import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetUserSettingsQueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	platform?: Types.Platform;
}>;

export type GetUserSettingsQuery = {
	__typename?: 'Query';
	settings: {
		__typename?: 'Settings';
		jwConsents?: {
			__typename?: 'JWConsents';
			google?: boolean | null;
			twitter?: boolean | null;
			facebook?: boolean | null;
			tiktok?: boolean | null;
			snapchat?: boolean | null;
			allother?: boolean | null;
			termsAndConditions?: boolean | null;
			emails?: boolean | null;
		} | null;
		ucConsents: Array<{ __typename?: 'UCConsent'; id: string; consent: boolean }>;
		providers: Array<{ __typename: 'Package'; id: string; shortName: string }>;
	};
};

export type UserJwConsentsFragment = {
	__typename?: 'JWConsents';
	google?: boolean | null;
	twitter?: boolean | null;
	facebook?: boolean | null;
	tiktok?: boolean | null;
	snapchat?: boolean | null;
	allother?: boolean | null;
	termsAndConditions?: boolean | null;
	emails?: boolean | null;
};

export type UserUcConsentsFragment = { __typename?: 'UCConsent'; id: string; consent: boolean };

export type UserSelectedPackagesFragment = { __typename: 'Package'; id: string; shortName: string };

export const UserJwConsentsFragmentDoc = gql`
	fragment UserJWConsents on JWConsents {
		google
		twitter
		facebook
		tiktok
		snapchat
		allother
		termsAndConditions
		emails
	}
`;
export const UserUcConsentsFragmentDoc = gql`
	fragment UserUCConsents on UCConsent {
		id
		consent
	}
`;
export const UserSelectedPackagesFragmentDoc = gql`
	fragment UserSelectedPackages on Package {
		__typename
		id
		shortName
	}
`;
export const GetUserSettingsDocument = gql`
	query GetUserSettings($country: Country!, $platform: Platform! = WEB) {
		settings {
			jwConsents {
				...UserJWConsents
			}
			ucConsents {
				...UserUCConsents
			}
			providers: selectedPackages(country: $country, platform: $platform) {
				...UserSelectedPackages
			}
		}
	}
	${UserJwConsentsFragmentDoc}
	${UserUcConsentsFragmentDoc}
	${UserSelectedPackagesFragmentDoc}
`;
